export const environment = {
    production: false,
    // Auth-M gateway base URL. `ng serve` uses THIS file, so it points at the
    // local gateway. For the deployed dev site, set this to
    // 'https://dev.hubware.app/api'.
    authMUrl: 'https://dev.hubware.app/api',
    authMDevHelpers: false,
    authApiUrl: 'https://dev.hubware.app/user-management',
    apiURL: 'https://dev.hubware.app/user-management',
    baseUrl: 'https://dev.hubware.app',
    filesApiUrl: 'https://dev.hubware.app/api/upload',
    eAtlasApiUrl: 'https://dev.hubware.app/api/imagepedia',
    cdnUrl: 'https://dev.hubware.app/gcs',
    coreApiUrl: 'https://dev.hubware.app/api/core',
    recaptchaKey: '6Lf8wgEgAAAAAHly0j9e51Uzi6dZ5PvyqDw9O9PB',
    placesApiKey: 'AIzaSyBaKgb5XgCiSjaPg0p3-IRChjjCyE94LQY',
};